import { inSectence, isGreeting } from "./utility-methods";


const replies = {
    "greetings": {
        message: "Hi there. Its nice to meet you. How can we help you?"
    },
    "study visa": {
        message: "Here are some useful replies to your query:",
        url: "/visa-programs",
        title: "Visa programs"
    },
    "scholarship": {
        message: "Here are some useful replies to your query:",
        url: "/visa-programs",
         title: "Schools and scholarships"
    },
    "work visa" :{
        message: "Here are some useful replies to your query:",
        url: "/visa-programs",
         title: "Visa programs"
    },
    "sorry": {
        message: "Sorry, we dont have any suggestions concerning the question you asked!",
        url: null,
        title: null
    }
}





export const getChatReply = ( message) => {

    const responseArray = [];
    

    if (inSectence('visa', message) || inSectence('work', message)){
        responseArray.push(replies["study visa"]);
    }

    if (inSectence('work', message) || inSectence('visas', message)){
       responseArray.push(["work visa"]);
    }

    if (inSectence('schools', message) || inSectence('scholarship', message)){
        responseArray.push(replies.scholarship);
    }



    if (isGreeting(message)) responseArray.unshift(replies.greetings);

    if (responseArray.length === 0) responseArray.unshift(replies.sorry);


     return responseArray;
    
}